import React, { useState, useEffect } from 'react'
import { Typography } from '@material-ui/core';
import { CloudDownload } from '@material-ui/icons';

import LoadingButton from '../../../../../Components/LoadingButton';
import SemDados from '../../../../../Components/SemDados';
import TableCustom from '../../../../../Components/Table';
import Loading from '../../../../../Components/Loading';

import { exportarRelatorioDetalhado, listarDetalhado } from '../../../../../Store/Actions/API/resultadosActions';
import { formataCnpj, formatarReais } from '../../../../../Utils/utils';
import { useStyles } from './styles';

export default function ListaResultados({ competencia, cpf, considerado = true }) {

    const classes = useStyles();

    const [loading, setLoading] = useState(false);
    const [isLoadingExportar, setLoadingExportar] = useState(false);

    const [pagination, setPagination] = useState({ pagina: 0, itensPorPagina: 100 });
    const [resultados, setResultados] = useState([]);
    const [quantidadeBanco, setQuantidadeBanco] = useState(0);

    useEffect(() => {        
        lidarListagemResultados();        
    }, [pagination]); // eslint-disable-line

    const lidarListagemResultados = async () => {
        const filtros = {
            ...pagination,
            cpf,
            considerado,
            competencia
        };

        setLoading(true);

        const response = await listarDetalhado(filtros);

        if (response !== null) {
            setQuantidadeBanco(response.quantidade ?? 0);
            setResultados(response.resultados ?? []);
        }

        setLoading(false);
    }

    const lidarExportarRelatorio = async () => {
        setLoadingExportar(true);
        await exportarRelatorioDetalhado({ cpf, competencia, considerado });
        setLoadingExportar(false);
    }

    const onChangePagination = (pag) => {
        setPagination(pag);
    }

    const columns = [
        {
            title: "Competência",
            dataIndex: "competencia",
            key: "competencia",
            width: 125,
            align: 'center',
            render: (value, row) => <p>{value}</p> 
        },
        {
            title: "Seq. Relação Prev.",
            align: 'center',
            width: 125,
            dataIndex: "sequencia",
            key: "sequencia"
        },
        {
            title: "Código Empregador",
            dataIndex: "codigoEmpregador",
            align: 'center',
            key: "codigoEmpregador",
            width: 155,
            render: (value) => <p>{value !== '-' ? formataCnpj(value) : value}</p>,
        },
        {
            title: "CNPJ Fonte Pagadora",
            dataIndex: "cnpjEmpregador",
            align: 'center',
            key: "cnpjEmpregador",
            width: 165,
            render: (value) => <p>{value !== '-' ? formataCnpj(value) : value}</p>,
        },
        {
            title: "Nome da Fonte Pagadora",
            dataIndex: "origemVinculo",
            align: 'center',
            key: "origemVinculo",
        },
        {
            title: "Tipo do Vínculo",
            align: 'center',
            width: 140,
            dataIndex: "tipoFiliadoVinculo",
            key: "tipoFiliadoVinculo",
        },
        {
            title: "Valor da Remuneração",
            dataIndex: "remuneracao",
            width: 150,
            key: "remuneracao",
            align: 'center',
            render: (value) =>  <p>{value !== '-' ? formatarReais(value) : value}</p>,
        },
        {
            title: "INSS Retido",
            dataIndex: "retencaoINSS",
            width: 120,
            align: 'center',
            key: "retencaoINSS",
            render: (value) => <p>{value !== '-' ? formatarReais(value) : value}</p>,
        }
    ];

    const propsTable = {
        columns: columns,
        data: resultados,
        optionsPagination: {
            count: quantidadeBanco,
            pagination,
            onChangePagination,
        },
        optionsToolbar: {
            info: (
                <div className={classes.rowHeader}>
                    <div className={classes.colTitle}>
                        <div style={{ paddingLeft: 5 }}>
                            <Typography className={classes.headerTitle}>Resultados</Typography>
                        </div>                        
                    </div>
                    <div className={classes.colButton}>
                        <div>
                            <LoadingButton
                                id="button_exportar_planilha"
                                variant="contained"
                                color="primary"
                                startIcon={<CloudDownload color={isLoadingExportar ? 'gray' : '#000000'} />}
                                onClick={lidarExportarRelatorio}
                                size={'small'}
                                loading={isLoadingExportar}
                                style={{ color: isLoadingExportar ? 'gray' : '#000000' }}
                            >
                                Exportar planilha
                            </LoadingButton>
                        </div>
                    </div>
                </div >
            ),
        },
        heightBody: "calc(100vh - 310px)",        
        minHeightBody: "calc(100vh - 310px)"
    };

    return (
        <>            
            {(!loading && resultados.length === 0) && (
                <SemDados text="Nenhum registro encontrado" />
            )}
            
            {(!loading && resultados.length > 0) && (
                <TableCustom {...propsTable} />
            )}
            
            {loading ? <Loading text={"Carregando resultados..."} zIndex2={true}/> : null}
        </>
    )
}